import { Component, inject } from '@angular/core';
import { BaseFilterComponent } from '../base-filter/base-filter.component';
import { Tag } from '../../../models/tag';
import { TagStore } from '../../../stores/tag/tag.state';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TreeSelectModule } from 'primeng/treeselect';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';

@Component({
  selector: 'app-tag-filter',
  standalone: true,
  imports: [
    FormsModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    NgIf,
    SharedModule,
    TreeSelectModule,
    TriStateCheckboxModule,
  ],
  templateUrl: './tag-filter.component.html',
  styleUrl: './tag-filter.component.scss',
})
export class TagFilterComponent extends BaseFilterComponent<Tag> {
  readonly store = inject(TagStore);

  constructor() {
    super();
  }
}
